import { HttpClient, JsonpClientBackend } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subscription, of } from 'rxjs';
import { delay, map, switchMap, take, takeWhile } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TranslationService implements OnDestroy {
  public defaultLanguage: Language = {
    language: 'en',
    name: 'English',
    engName: 'English',
  };

  private key = '?key=AIzaSyAFOBquB54y9qXcc3QUjfeE6vJprBCYnPg';
  private url = 'https://translation.googleapis.com/language/translate/v2';

  request$: Subscription;
  response$: Subscription;
  request = new BehaviorSubject(<number[]>[]);
  response = new BehaviorSubject(<number[]>[]);

  http: HttpClient;
  constructor(handler: JsonpClientBackend) {
    this.http = new HttpClient(handler);

    this.request$ = this.request
      .pipe(switchMap((x) => of(x).pipe(takeWhile((x) => !!x.length), delay(300))))
      .subscribe(() => this.response$ = this.response
        .pipe(switchMap((x) => of(x)
        .pipe(takeWhile((x) => (x.length === this.request.value.length)))))
        .pipe(take(1)).subscribe(() =>  {
          this.request.next([]);
          this.response.next([]);
        }));
  }

  ngOnDestroy(): void {
    this.response$?.unsubscribe();
    this.request$?.unsubscribe();
  }

  getTranslation(text: string, language: string) {
    this.request.next([...this.request.value, this.request.value.length]);
    return this.http
      .jsonp(`${this.url}${this.key}&q=${encodeURIComponent(text)}&target=${language}&format=text`, 'callback')
      .pipe(
        map((result: any) => {
          this.response.next([...this.response.value, this.response.value.length]);
          return result.data.translations[0].translatedText;
        })
      );
  }

  getLanguages(): Observable<any> {    
    return this.http
      .jsonp(`${this.url}/languages${this.key}`, 'callback')
      .pipe(map((result: any) => result.data.languages));
  }
}

export class Language {
  language: string;
  name: string;
  engName: string;
}
